/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { FormFieldComponentDelegate } from '../core/delegates';
import { TEXT_FIELD_CONSTANTS } from '../text-field';
import { DATE_RANGE_PICKER_CONSTANTS } from './date-range-picker-constants';
export class DateRangeComponentDelegate extends FormFieldComponentDelegate {
    constructor(config) {
        super(config);
    }
    _build() {
        const dateRangePicker = document.createElement(DATE_RANGE_PICKER_CONSTANTS.elementName);
        this._attachTextField(dateRangePicker);
        return dateRangePicker;
    }
    get fromInput() {
        return this._textField.querySelector('input:first-of-type');
    }
    get toInput() {
        return this._textField.querySelector('input:last-of-type');
    }
    get textField() {
        return this._textField;
    }
    get value() {
        return this._element.value;
    }
    set value(value) {
        this._element.value = value;
    }
    get disabled() {
        return this._element.disabled;
    }
    set disabled(value) {
        this._element.disabled = value;
    }
    get invalid() {
        return this._textField.invalid || false;
    }
    set invalid(value) {
        this._textField.invalid = value;
    }
    onChange(listener) {
        this._element.addEventListener(DATE_RANGE_PICKER_CONSTANTS.events.CHANGE, (evt) => listener(evt.detail));
    }
    onFocus(listener) {
        this._element.addEventListener('focusin', (evt) => {
            const isFocusWithin = !this._element.contains(evt.relatedTarget);
            if (isFocusWithin) {
                listener(evt);
            }
        });
    }
    onBlur(listener) {
        this._element.addEventListener('focusout', (evt) => {
            const isFocusOutside = !this._element.contains(evt.relatedTarget);
            if (isFocusOutside) {
                listener(evt);
            }
        });
    }
    _attachTextField(dateRangePicker) {
        this._textField = document.createElement(TEXT_FIELD_CONSTANTS.elementName);
        if (this._config.options?.required) {
            this._textField.required = true;
        }
        if (this._config.options?.density) {
            this._textField.density = this._config.options.density;
        }
        this._fromInput = document.createElement('input');
        this._fromInput.type = 'text';
        this._fromInput.placeholder = this._config.options?.fromPlaceholder || 'From';
        this._textField.appendChild(this._fromInput);
        this._toInput = document.createElement('input');
        this._toInput.type = 'text';
        this._toInput.placeholder = this._config.options?.toPlaceholder || 'To';
        this._textField.appendChild(this._toInput);
        const label = document.createElement('label');
        label.textContent = this._config.options?.label || 'Choose date range';
        this._textField.appendChild(label);
        dateRangePicker.appendChild(this._textField);
    }
}
